export default "__VITE_ASSET__CjKuRDjs__"